
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons/faInfoCircle';
import { faAsterisk } from '@fortawesome/free-solid-svg-icons/faAsterisk';

const Wrapper = styled.div`
  display: flex;
  margin-bottom: ${({ theme }) => theme.spacing}px;
  .childrenWrapper{
    margin: 0 0 0 0.5em;
    line-height:1.6;
  }
  .icon {
    line-height: 1.4;
    font-size: 1.2em;
  }

  .asterisk {
    color: white;
    display: flex;
    position: relative;
    line-height:1;
    align-items: center;
    justify-content: center;
    width: 1em;
    height: 1em;
    margin-top: 1px;
    svg{
      position: relative;
      font-size: 0.5em;
    }
    &:before{
      content:"";
      position: absolute;
      width: 1em;
      height: 1em;
      background-color: black;
      border-radius: 2em;
    }
  }
`;

const InfoBox = ({ className, children, asterisk }) => {
  const classes = ['InfoBox'];
  if (className) classes.push(className);

  return (
    <Wrapper className={classes.join(' ')}>
      <span className="icon">
        {asterisk ? (
          <span className="asterisk">
            <FontAwesomeIcon icon={faAsterisk} />
          </span>

        ) : (
          <FontAwesomeIcon icon={faInfoCircle} />
        )}
      </span>
      <div className="childrenWrapper">{children}</div>
    </Wrapper>
  );
};

InfoBox.displayName = 'InfoBox';

InfoBox.propTypes = {
  className: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.string,
    PropTypes.node,
  ]).isRequired,
  asterisk: PropTypes.bool,
};

InfoBox.defaultProps = {
  className: null,
  asterisk: false,
};

export default InfoBox;
